import { connect } from 'react-redux'
import Group from './group'
import { getPupilGroup } from '../../../../../../../../stores/profile/profile.selectors'
import { removePupilFromGroup } from '../../../../../../../../stores/profile/profile.actions'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { id }) => {
  const group = getPupilGroup(state, id)
  return {
    mis: group.mis_group,
    title: group.title,
    editable: group.policy.can_manage_students_for_group
  }
}

const mapDispatchToProps = (dispatch, { id, match }) => ({
  onDelete: () =>
    dispatch(
      removePupilFromGroup({
        student_account_id: match.params.id,
        group_id: id
      })
    )
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Group)
)
